export const MAX_COVER_CROP_FRACTION = 0.5;

// Fraction of the original image lost when object-fit: cover fills a box.
export function coverCropFraction(imageWidth, imageHeight, boxWidth, boxHeight) {
  if (![imageWidth, imageHeight, boxWidth, boxHeight].every(value => value > 0)) return 0;
  const imageRatio = imageWidth / imageHeight;
  const boxRatio = boxWidth / boxHeight;
  return 1 - Math.min(imageRatio / boxRatio, boxRatio / imageRatio);
}

export function fitCover(imageWidth, imageHeight, boxWidth, boxHeight) {
  const scale = Math.min(boxWidth / imageWidth, boxHeight / imageHeight);
  return { width: imageWidth * scale, height: imageHeight * scale };
}
